import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type { OrgTenant } from "../api/client.ts";

/**
 * Whether an organization owns a tenant it is linked to ("Primary", plus who
 * else it is shared with) or only has it shared ("Owned by …").
 */
export default function OwnershipChip({ link }: { link: Pick<OrgTenant, "is_primary" | "primary_organization" | "shared_with"> }) {
  if (!link.is_primary) {
    return <Chip size="small" variant="outlined" label={`Owned by ${link.primary_organization?.name ?? "—"}`} />;
  }
  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
      <Chip size="small" color="primary" label="Primary" />
      {link.shared_with.length > 0 && (
        <Tooltip title={link.shared_with.map((o) => o.name).join(", ")}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Shared with {link.shared_with.length}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
}
